import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X, Plus } from "lucide-react";

interface SellingPointsEditorProps {
  value: string[];
  onChange: (points: string[]) => void;
}

export function SellingPointsEditor({ value, onChange }: SellingPointsEditorProps) {
  const [newPoint, setNewPoint] = useState("");

  const addPoint = () => {
    if (newPoint.trim()) {
      onChange([...value, newPoint.trim()]);
      setNewPoint("");
    }
  };

  const removePoint = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <Input
          placeholder="Enter a key benefit or feature..."
          value={newPoint}
          onChange={(e) => setNewPoint(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addPoint();
            }
          }}
        />
        <Button type="button" onClick={addPoint} size="sm" variant="secondary">
          <Plus className="w-4 h-4 mr-1" />
          Add
        </Button>
      </div>

      {value.length > 0 && (
        <ul className="space-y-2">
          {value.map((point, index) => (
            <li
              key={index}
              className="flex items-start gap-2 p-2 rounded-md bg-muted/50 border"
            >
              <span className="text-sm flex-1">{point}</span>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => removePoint(index)}
                className="h-6 w-6 p-0"
              >
                <X className="w-3 h-3" />
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
